module.exports = __webpack_public_path__ + "img/Sterowanie małym robotem.5bf67778.jpg";